export const CONTACT_INFO = {
  email: "woloshindima@gmail.com",
  linkedin: "linkedin.com/in/voloshynd",
  linkedinUrl: "https://linkedin.com/in/voloshynd",
  location: "Calgary, Canada",
};
